import "./App.css";
import ShoppingListApp from "./components/ShoppingListApp";

function App() {
  return (
    <div className="App">
      <ShoppingListApp />
    </div>
  );
}

export default App;
